










































































































































































































import Vue from "vue";
import {
  ExerciseEmitData,
  SetEmitData,
  SetChangeType,
} from "@/interfaces/exercise.interface";
import { WeightSet } from "@/interfaces/sets.interface";
export default Vue.extend({
  props: {
    exercise: Object,
    exerciseIdx: Number,
    previousSets: Array as () => WeightSet[], // convert to generic of sets
  },
  data() {
    return {
      seeVideo: true,
    };
  },
  methods: {
    emitSetValues(setIdx: number, type: SetChangeType, addNote?: boolean) {
      let setEmitData: SetEmitData = {
        exerciseIdx: this.exerciseIdx,
        setChangeType: type,
        setIdx,
      };

      if (type === "Set Note" && addNote) setEmitData.addNote = true;
      if (type === "Replace Set Values") {
        const setValues: WeightSet = {
          weight: 0,
          reps: 0,
        };
        if (setIdx < this.previousSets.length - 1) {
          setValues.weight = this.previousSets[setIdx].weight;
          setValues.reps = this.previousSets[setIdx].reps;
        }
        setEmitData.newValues = setValues;
      }

      this.$emit("changeSetValue", setEmitData);
    },
    changeSetVideo(video: Blob | undefined, setIdx: number): void {
      let exerciseEmitData: ExerciseEmitData = {
        setIdx,
        video,
        exerciseIdx: this.exerciseIdx,
      };
      this.$emit("changeSetVideo", exerciseEmitData);
    },
    changeSetNote(setIdx: number, addNote: boolean) {
      let exerciseEmitData: ExerciseEmitData = {
        setIdx,
        addNote,
        exerciseIdx: this.exerciseIdx,
      };
      this.$emit("changeSetNote", exerciseEmitData);
    },
    removeExercise() {
      this.$emit("removeExercise", this.exerciseIdx);
    },
    formattedPreviousSet(setIdx: number): string {
      if (setIdx > this.previousSets.length - 1) return " ";
      return `${this.previousSets[setIdx].weight} x ${this.previousSets[setIdx].reps}`;
    },
  },
  computed: {
    exercyseType(): "Cardio" | "Reps" | "Duration" | "Weights" | undefined {
      let exerciseType = this.exercise.type;
      if (exerciseType === "Cardio") return "Cardio";
      if (exerciseType === "Reps") return "Reps";
      if (exerciseType === "Duration") return "Duration";
      if (
        exerciseType === "Barbell" ||
        exerciseType === "Dumbbell" ||
        exerciseType === "Machine" ||
        exerciseType === "Weighted Bodyweight" ||
        exerciseType === "Assisted Bodyweight"
      )
        return "Weights";

      return undefined;
    },
  },
});
